import React from 'react'
import Head from "next/head";
import { useRouter } from 'next/router';

function Canonical({url}:{url?:string}) {
    const pathname = useRouter();
  return (
      <Head>
         {
          (url === undefined || url === "") ?
          <link rel="canonical" href={`https://www.bonatra.com${pathname.asPath}`}/>
          : <link rel="canonical" href={url}/>
      }      
      </Head>
  )
}

export default Canonical